import { useQuery } from '@tanstack/react-query';

import type { Survey } from 'src/types/survey';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';
import { useUserContext } from 'src/components/app/context/UserContext';

/**
 * Fetches the global survey from the API
 * @returns The global survey data
 */
const fetchGlobalSurvey = async (endpoint: string) =>
  (await HttpService.get(endpoint)).data;

/**
 * Hook to fetch and return the global survey.
 * @returns The query result containing the global survey.
 */
const useGlobalSurvey = (enabled = true) => {
  const { user } = useUserContext();
  const endpoint = apiPaths.SURVEY.GET_GLOBAL;

  return useQuery<Survey>({
    queryKey: [endpoint, user],
    queryFn: async () => await fetchGlobalSurvey(endpoint),
    enabled,
  });
};

export default useGlobalSurvey;
